import IconChevronDown from '@/assets/icons/font_awesome/chevron-down-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { useTranslation } from 'react-i18next';

export function DropdownSettingUserLanguage() {
  const { t, i18n } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const { user_settings } = use_slice_user(['user_settings']);

  const trigger_id = 'dropdown_setting_user_language';

  /*
   * EVENTS
   */
  async function on_item_selected(value: string) {
    const settings_new = user_settings.clone({ regional_language: value });

    await FN_USER_SETTINGS__update(settings_new);
  }

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_items() {
    return Object.values(CONSTANTS__shared.SUPPORTED_LANGUAGES).map(value => {
      return (
        <UI_PRIMITIVE__dropdown_menu_item
          key={value}
          class_name_hovered_selected={`bg-component-item`}
          values_selected={[user_settings.regional_language]}
          label={t(i18n_page_settings_user.tabs.regional.dropdown.language.item[value])}
          {...{ on_item_selected, value }}
          className={`settings-dropdown-item  text-page-foreground`}
        />
      );
    });
  }

  /*
   * HTML
   */
  return (
    <div className="settings-dropdown-wrapper ">
      <span>{t(i18n_page_settings_user.tabs.regional.dropdown.language.label)}: </span>

      <UI_PRIMITIVE__dropdown_menu>
        <UI_PRIMITIVE__dropdown_menu_trigger asChild>
          <UI_PRIMITIVE__button id={trigger_id} className="settings-dropdown-button mt-1  text-page-foreground" variant="outline-on-component">
            {t(i18n_page_settings_user.tabs.regional.dropdown.language.item[user_settings.regional_language])}
            <IconChevronDown className="!w-3 !h-3" />
          </UI_PRIMITIVE__button>
        </UI_PRIMITIVE__dropdown_menu_trigger>
        <UI_PRIMITIVE__dropdown_menu_content trigger_id={trigger_id} className="rounded-lg">
          {render_items()}
        </UI_PRIMITIVE__dropdown_menu_content>
      </UI_PRIMITIVE__dropdown_menu>
    </div>
  );
}
